// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"3c5b6124","463":"f478664e"}[chunkId] + ".chunk.css";
};